import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { black, ButtonBrand, gold, white } from '../../../getLPTheme';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider/Divider';
import { Collapse, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { options } from '@config';
import Loading from '../../../auxiliares/loading';

export default function Register() {
    const paperStyleMedium = { height: 'auto', width: 500, alignItems: "center", justifyContent: "center" };
    const paperStyleSmall = { height: '75vh', width: 340, alignItems: "center", justifyContent: "center" };
    const btnstyle = { margin: '8px 0' };
    const typographyStyle = { color: white[50] };
    const [openProgress, setopenProgress] = React.useState(false);
    const [openButton, setopenButton] = React.useState(true);
    const [openMessage, setopenMessage] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [error, setError] = React.useState('');

    const [showPassword, setShowPassword] = React.useState(false);
    const [formData, setFormData] = React.useState({
        user: '',
        password: '',
        confirmPassword: '',
        email: '',
        name: '',
        lastname: '',
        phone: '',
        dni: '',
        matricula: '',
    });
    const navigate = useNavigate();

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => { event.preventDefault(); };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        setopenButton(false)
        setopenProgress(true)
        e.preventDefault();
        if (formData.password !== formData.confirmPassword) {
            setopenProgress(false)
            setopenButton(true)
            setError('Las contraseñas no coinciden');
            return;
        }

        const response = await fetch((options.api.url + "register"), {
            method: 'POST',
            mode: "cors",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        const data = await response.json();


        if (response.status === 200) {
            setopenProgress(false)
            setopenButton(true)
            setMessage('Registro exitoso!')
            setTimeout(function(){
                navigate('/login');
            }, 2000);
            
        } else {
            setopenProgress(false)
            setopenButton(true)
            if (data.error === 'Could not create user, email already exists') {
                setError('Error al registrarse. El email ya fue utilizado anteriormente');
            } else {
                setError('Error al intentar registrase. Por Favor intente nuevamente');
            }
        }
    };

    return (
        <Container
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                pt: { xs: 10, sm: 12 },
                pb: { xs: 4, sm: 6 },
            }}
        >
            <Box
                sx={{
                    borderRadius: 1,
                    border: 1,
                    borderColor: gold[500],
                    display: { xs: 'none', md: 'flex' },
                    gridTemplateColumns: { md: '1fr 1fr' },
                    width: 502,
                    height:'100%',
                    direction: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <Paper elevation={24} style={paperStyleMedium} sx={{backgroundColor: black[1000]}}>
                    <Box sx={{ padding: 1 }}>
                        <Typography color={white[50]}>World Golf Club</Typography>
                        <Divider />
                        <form onSubmit={handleSubmit} autoComplete="off">
                            <Grid container direction="row" justifyContent="center" alignItems="center">
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Nombre
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        variant="outlined"
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu nombre'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 70 } }}
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Apellido
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu apellido'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 70 } }}
                                        name="lastname"
                                        value={formData.lastname}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Correo electrónico:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu email'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Número de teléfono:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu teléfono'
                                        type='string'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Documento:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu documento de identidad'
                                        type='string'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        name="dni"
                                        value={formData.dni}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Matrícula:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu Matrícula AAG'
                                        type='string'
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        name="matricula"
                                        value={formData.matricula}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Contraseña:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu contraseña'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        type={showPassword ? 'text' : 'password'}
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Repetí tu Contraseña:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Repetí tu contraseña'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        type={showPassword ? 'text' : 'password'}
                                        name="confirmPassword"
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ pt: 2 }}>
                                    <Collapse in={openButton}>
                                        <ButtonBrand type='submit' color='primary' variant="contained" style={btnstyle} sx={{ width: 400 }}>Registrarme</ButtonBrand>
                                    </Collapse>    
                                    <Collapse in={openProgress}>
                                        <Box sx={{width:"100%", display: "flex", justifyContent:"center", alignItems:"center"}}>
                                            <Loading/>
                                        </Box>
                                    </Collapse>    
                                </Grid>
                                <Grid item xs={12} sx={{ pt: 1 }}>
                                    <Typography>
                                        <RouterLink to={"/login"} style={{ textDecoration: 'none' }}>
                                            <Link>
                                                Ya estás registrado?  Inicia Sesión!
                                            </Link>
                                        </RouterLink>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sx={{ pt: 1 }}>
                                    {error && <Typography color="#e89b9b">{error}</Typography>}
                                </Grid>
                                <Grid item xs={12} sx={{ pt: 1 }}>
                                    {message && <Typography color="#18f011">{message}</Typography>}
                                </Grid>
                            </Grid>
                        </form>
                        <Divider />
                    </Box>
                </Paper>
            </Box>
            {/* PANTALLA CHICA */}
            <Box
                sx={{
                    borderRadius: 1,
                    border: 1,
                    borderColor: gold[500],
                    display: { xs: 'flex', sm: 'none', md: 'none', lg: 'none', xl: 'none' },
                    gridTemplateColumns: { md: '1fr 1fr' },
                    width: 342,
                    height: '100%',
                    direction: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <Paper elevation={24} style={paperStyleSmall} sx={{backgroundColor: black[1000]}}>
                    <Box sx={{ padding: 1 }}>
                        <Typography color={white[50]}>World Golf Club</Typography>
                        <Divider />
                        <form onSubmit={handleSubmit}>
                            <Grid container direction="row" justifyContent="center" alignItems="center">
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Nombre
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        variant="outlined"
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu nombre'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 70 } }}
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Apellido
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu apellido'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 70 } }}
                                        name="lastname"
                                        value={formData.lastname}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Correo electrónico:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu email'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Número de teléfono:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu teléfono'
                                        type='string'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Documento:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu documento de identidad'
                                        type='string'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        name="dni"
                                        value={formData.dni}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Matrícula:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        InputLabelProps={{ shrink: false }}
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu Matrícula AAG'
                                        type='string'
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        name="matricula"
                                        value={formData.matricula}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Contraseña:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Ingresa tu contraseña'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        type={showPassword ? 'text' : 'password'}
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={typographyStyle}>
                                        Repetí tu Contraseña:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        label=''
                                        placeholder='Repetí tu contraseña'
                                        required
                                        sx={{ width: 220, "& .MuiInputBase-root": { minWidth: 150 } }}
                                        type={showPassword ? 'text' : 'password'}
                                        name="confirmPassword"
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ pt: 2 }}>
                                    <Collapse in={openButton}>
                                        <ButtonBrand type='submit' sx={{ width: 300 }}>Registrarme</ButtonBrand>
                                    </Collapse>    
                                    <Collapse in={openProgress}>
                                        <Box sx={{width:"100%", display: "flex", justifyContent:"center", alignItems:"center"}}>
                                            <Loading/>
                                        </Box>
                                    </Collapse>    
                                </Grid>
                                <Grid item xs={12} sx={{ pt: 1 }}>
                                    <Typography>
                                        <RouterLink to={"/login"} style={{ textDecoration: 'none' }}>
                                            <Link>
                                                Ya estás registrado?  Inicia Sesión!
                                            </Link>
                                        </RouterLink>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </form>
                        <Divider />
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
}
